import type { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

function SettingsSection({ children, className, ...props }: ComponentProps<'div'>) {
  return (
    <div data-slot="settings-section" className={twMerge('space-y-2.5 pt-2.5', className)} {...props}>
      {children}
    </div>
  )
}

function SettingsSectionTitle({ children, className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="settings-section-title"
      className={twMerge('text-foreground-placeholder type-ui-sm flex items-center gap-2 font-medium', className)}
      {...props}
    >
      {children}
    </div>
  )
}

function SettingsSectionDescription({ className, children, ...props }: ComponentProps<'p'>) {
  return (
    <p
      data-slot="section-description"
      className={twMerge('text-foreground-secondary type-prose-sm', className)}
      {...props}
    >
      {children}
    </p>
  )
}

function SettingsSectionContainer({ children, className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="section-container"
      className={twMerge(
        'group flex items-center justify-between gap-3 rounded-xl border p-3 transition-colors',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export { SettingsSection, SettingsSectionTitle, SettingsSectionDescription, SettingsSectionContainer }
